<template>
  <div class="sw--position-bottom
                sw--position-left
                sw--position-right
                sw--position-fixed
                sw--padding-hor-4
                sw--padding-vert-2
                sw-dms--bg-white
                sw--z-index-10
                sw-grid-flex
                sw--border-grey-64-1
                sw-grid-flex--align-center"
       :class="showSaveBtn ? 'sw-grid-flex--justify-flex-end' : 'sw-grid-flex--justify-center'">
    <div v-if="showSavedMessage" class="sw--font-size-14 sw--margin-right-3 sw-grid-flex sw-grid-flex--align-center">
      <span class="icon-checkmark-circled sw--text-green sw--font-size-18 sw--padding-hor-2"></span>This section has been saved
    </div>
    <div v-else-if="hasMissingInfo" class="sw--font-size-14 sw--margin-right-3 sw-grid-flex sw-grid-flex--dir-column">
      You can only save this section after saving:
      <span class="sw-dms--color-red-error sw--font-weight-bold" v-for="info in missingInfo">&#9679; {{info}}</span>
    </div>
    <button v-if="showAddNewBtn && showSaveBtn"
            class="sw-dms-button sw-dms-button--big sw--margin-right-3"
            @click="$emit('add-new')">
      Add New
    </button>
    <button v-if="showCancelBtn && !showSavedMessage"
            class="sw-dms-button sw-dms-button--big sw--margin-right-3"
            @click="$emit('cancel')">
      Cancel
    </button>
    <button v-if="showSaveBtn"
            class="sw-dms-button sw-dms-button--red sw-dms-button--big"
            @click="$emit('saved')">Save
    </button>

  </div>
</template>

<script>
    export default {
        name: "bottom-banner",
        props: {
            missingInfo: {
                type: Array,
                required: false,
                default: []
            },
            showUpdateBtn: {
                type: Boolean,
                required: false,
                default: () => (false)
            },
            showAddNewBtn: {
                type: Boolean,
                required: false,
                default: () => (false)
            },
            showCancelBtn: {
                type: Boolean,
                required: false,
                default: () => (false)
            },
            showSavedMessage : {
              type: Boolean,
              required: false,
              default:  () => (false)
            }
        },
        computed: {
            hasMissingInfo() {
                return this.missingInfo.length > 0;
            },
            showSaveBtn() {
                return !this.hasMissingInfo && !this.showSavedMessage
            }
        }
    }
</script>
